import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  removeBasketItems,
  removeFromCart,
} from "../../redux/feature/cartReducer";

const PaymentItem = ({ id, image, title, price, quantity, totalPrice }) => {
  const dispatch = useDispatch();
  const totalQuantity = useSelector((state) => state.cart.totalQuantity);

  const [loading, setLoading] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [animationItemClass, setAnimationItemClass] = useState(
    "animate__animated animate__fadeInRight"
  );
  const [show, setShow] = useState(false);
  const [quantityLoading, setQuantityLoading] = useState(false);

  const incCartitems = () => {
    setQuantityLoading(true);
    setTimeout(() => {
      setQuantityLoading(false);
      dispatch(addToCart({ id, title, price }));
    }, 300);
  };

  const descCartitems = () => {
    setQuantityLoading(true);
    if (quantity === 1) {
      setShow(true);
      setAnimationClass("animate__animated animate__fadeInRight");
      setQuantityLoading(false);
      //! 10 saniye sonra show state'i false olsun
      setTimeout(() => {
        setShow(false);
        setAnimationClass("animate__animated animate__fadeOutLeft");
      }, 10000);
    } else {
      setTimeout(() => {
        setQuantityLoading(false);
        dispatch(removeFromCart(id));
      }, 300);
    }
  };

  const handleYesClick = () => {
    if (totalQuantity === 1) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        dispatch(removeBasketItems());
        setAnimationClass("animate__animated animate__fadeOutLeft");
        window.scrollTo(0, 0);
      }, 500);
      setAnimationItemClass("animate__animated animate__fadeOutLeft");
    } else {
      setTimeout(() => {
        dispatch(removeFromCart(id));
        setAnimationClass("animate__animated animate__fadeOutLeft");
      }, 500);
      setAnimationItemClass("animate__animated animate__fadeOutLeft");
    }
  };

  const handleNoClick = () => {
    setAnimationClass("animate__animated animate__fadeOutLeft");
    setTimeout(() => {
      setShow(false);
    }, 500);
  };

  return (
    <>
      {loading && (
        <div className="loading-gif">
          <span className="loader"></span>
        </div>
      )}
      <div className={`payment-flex  ${animationItemClass}`}>
        {show && (
          <div className={`payment-boot-modal ${animationClass}`}>
            <h6 className="text-center mt-4">Delete Product?</h6>
            <div className="payment-boot-modal-buttons">
              <button onClick={handleYesClick}>Yes</button>

              <button onClick={handleNoClick}>No</button>
            </div>
          </div>
        )}
        <img className="payment-img" src={image} alt="item" />

        <div className="payment-button">
          {quantity === 1 && (
            <button
              title="Delete"
              onClick={descCartitems}
              className="btn-minus"
            >
              <i className="payment-trash-btn quantity-one fas fa-solid fa-trash-can animate__animated animate__fadeIn"></i>
            </button>
          )}
          {quantity > 1 && (
            <button onClick={descCartitems} className="btn-minus fw-bold">
              -
            </button>
          )}
          {quantityLoading ? (
            <span className="payment-quantity-loader-parent">
              <span className="payment-quantity-loaderGif"></span>
            </span>
          ) : (
            <span className="payment-quantity animate__animated animate__fadeIn">
              {quantity}
            </span>
          )}
          <button onClick={incCartitems} className="btn-plus fw-bold">
            +
          </button>
        </div>
        <div className="totalPrice">${totalPrice.toFixed(2)}</div>
      </div>
    </>
  );
};

export default PaymentItem;
